/*
	Redux reporter - logs to our error endpoint depending on the action type
*/
import addAppErrorLogEntry from '../../dataservices/addAppErrorLogEntry'

const shouldLogToEndpoint = (action) => {
	const loggableActionsTests = ['_FAIL', '_ERROR']
	const actionType = action ? action.type : ''
	let shouldLog = false

	loggableActionsTests.forEach((lKey) => {
		if (actionType.indexOf(lKey) !== -1) {
			shouldLog = true
		}
	})
	return shouldLog
}

/* eslint-disable no-unused-vars */
const reporter = store => next => (action) => {
	if (shouldLogToEndpoint(action)) {
		addAppErrorLogEntry(action, store)
	}

	try {
		return next(action)
	} catch (error) {
		addAppErrorLogEntry(action, store, { error, stack: error.stack })
		throw error
	}
}

export default reporter



// WEBPACK FOOTER //
// ./src/redux/middleware/reporter.js